module.exports = __webpack_public_path__ + "img/green.2cdac446.png";